import { render, staticRenderFns } from "./BottomTabbar.vue?vue&type=template&id=1389115a"
import script from "./BottomTabbar.vue?vue&type=script&lang=ts"
export * from "./BottomTabbar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports